import { SideSheetBody, Box } from '@bechtel/gds';
import styled from 'styled-components';

export const SideSheetBodyStyled = styled(SideSheetBody)`
  flex-direction: column;
`;

export const CaddySelectorStyled = styled(Box).attrs({ mt: { sm: '600' }, px: { sm: '500' } })`
  opacity: 50%;
  pointer-events: none;
`;
